export default {
  setCocinas(state,c){
    state.cocinasArray = c;
  }
}